/** @format */

import { Button, Dialog } from '@king-design/react'
import React, { useRef, useState, useEffect, FC } from 'react'
import styled from 'styled-components'

interface EllipsisTwoLinesProps {
  className?: string
  children: string
  title?: string
}

const EllipsisTwoLines: FC<EllipsisTwoLinesProps> = ({ className, title, children }) => {
  const [show, setShow] = useState<boolean>(false)
  const pRef = useRef<HTMLParagraphElement>(null)

  const onShowMore = () => {
    setShow(true)
  }

  useEffect(() => {
    const maxHeight = 2 * 18 // 两行文本的最大高度，假设每行高度为24px
    if (pRef.current && pRef.current.scrollHeight > maxHeight) {
      const haveMore = pRef.current.parentNode.querySelector('.read_more')
      if (!haveMore) {
        // 显示 "查看全部" 链接
        const readMoreLink = document.createElement('a')
        readMoreLink.className = 'read_more'
        readMoreLink.textContent = '查看全部'
        readMoreLink.onclick = onShowMore
        pRef.current.parentNode.appendChild(readMoreLink)
      }
    }
  }, [onShowMore])

  return (
    <div className={className}>
      <p className="text_content" ref={pRef}>
        {children}
      </p>
      <Dialog
        title={title || '提示'}
        value={show}
        onChangeValue={value => {
          setShow(value)
        }}
        slotFooter={<Button onClick={() => setShow(false)}>关闭</Button>}
      >
        <p style={{ wordBreak: 'break-all', marginBottom: 0 }}>{children}</p>
      </Dialog>
    </div>
  )
}

export default styled(EllipsisTwoLines)`
  .text_content {
    margin-bottom: 0;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 限制显示 2 行 */
    overflow: hidden;
    text-overflow: ellipsis; /* 超出部分显示省略号 */
    line-height: 18px;
  }
`
